module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_sp_3-63ff5889d1346b7a566ed4f164a963ed.jpg";